import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
/*import { utils } from "../common/utils";*/

class Services extends Component {
    render() {
        const { t, settings, siteLinks } = this.props;

        //const joinUsLinks = settings.footerLinks.filter(link => link.isJoinUsLink === true && (utils.isNullOrEmpty(link.locale) || link.locale === locale)),
        //    warrantyLinks = settings.footerLinks.filter(link => link.isWarrantyLink === true && (utils.isNullOrEmpty(link.locale) || link.locale === locale)),
        //    joinUsLink = joinUsLinks && joinUsLinks.length > 0 ? joinUsLinks[0] : null,
        //    warrantyLink = warrantyLinks && warrantyLinks.length > 0 ? warrantyLinks[0] : null;
        let becomeEprLink = siteLinks && siteLinks.becomeEprLink ? siteLinks.becomeEprLink.contentUrl : null,
            becomeEprLinkTarget = siteLinks && siteLinks.becomeEprLink  ? "_blank" : "_self",
            becomeEprTitle = siteLinks && siteLinks.becomeEprLink ? siteLinks.becomeEprLink.name : t("Become an ENJOpreneur"),
            warrantyLink = siteLinks && siteLinks.warrantyLink ? siteLinks.warrantyLink.contentUrl : null,
            warrantyLinkTarget = siteLinks && siteLinks.warrantyLink ? "_blank" : "_self",
            warrantyTitle = siteLinks && siteLinks.warrantyLink ? siteLinks.warrantyLink.name : t("100% Satisfaction");

        return (
            <section className="container padding-top-3x padding-bottom-2x services">
                <div className="row">
                    <div className="col-md-3 col-sm-6 text-center mb-30">
                        <a rel="noopener noreferrer" target={becomeEprLinkTarget} href={becomeEprLink}>
                            <img
                                className="d-block w-90 img-thumbnail rounded-circle mx-auto mb-3"
                                src="img/services/01.png"
                                alt={becomeEprTitle}
                            />
                        </a>

                        <a rel="noopener noreferrer" target={becomeEprLinkTarget} href={becomeEprLink}><h6> {becomeEprTitle}</h6></a>
                        <p className="text-muted margin-bottom-none">
                            {t("Love ENJO? Start your ENJO business today")} 
                        </p>
                    </div>
                    <div className="col-md-3 col-sm-6 text-center mb-30">
                        <a rel="noopener noreferrer" target={warrantyLinkTarget} href={warrantyLink}>
                            <img
                                className="d-block w-90 img-thumbnail rounded-circle mx-auto mb-3"
                                src="img/services/02.png"
                                alt={warrantyTitle}
                            />
                        </a>

                        <a rel="noopener noreferrer" target={warrantyLinkTarget} href={warrantyLink}><h6> {warrantyTitle}</h6></a>
                        <p className="text-muted margin-bottom-none">
                            {t("WarrantyDescription")} 
                        </p>
                        
                    </div>
                    <div className="col-md-3 col-sm-6 text-center mb-30">
                        <img
                            className="d-block w-90 img-thumbnail rounded-circle mx-auto mb-3"
                            src="img/services/03.png"
                            alt={t("Support")}
                        />
                        <h6>{t("Customer Support")}</h6>
                        <p className="text-muted margin-bottom-none">
                            {t("We pride ourselves on personal service")}

                        </p>
                    </div>
                    <div className="col-md-3 col-sm-6 text-center mb-30">
                        <img
                            className="d-block w-90 img-thumbnail rounded-circle mx-auto mb-3"
                            src="img/services/04.png"
                            alt={t("Payment")}
                        />
                        <h6>{t("Secure Online Payment")}</h6>
                        <p className="text-muted margin-bottom-none">
                            {t("We posess SSL / Secure Certificate")}

                        </p>
                    </div>
                </div>
            </section>
        );
    }
}


function mapStateToProps({ settings, siteLinks }, ownProps) {
    return { settings, siteLinks, ...ownProps };
}


export default withTranslation()(connect(mapStateToProps, null)(Services));


